import React, {memo} from 'react';

import FolderPage from '../components/folder/folderpage';
import {FolderType} from '../types';
import FolderLibrary from '../components/folder/folderlibrary';
import {useFolders} from '../hooks/useFolders';
import EditorProject from '../components/editor/editorproject';
import {getFolderContent, getFoldersByType, writeItem} from '../api';
import {EditorStackParams} from '../types/nav';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {CameraScreen} from '../components/camera/camera';

const folderType = FolderType.editor;
const EditorStack = createNativeStackNavigator<EditorStackParams>();

const FolderComponent = memo(() => (
  <FolderPage folderType={folderType} />
));
const FolderLibraryComponent = memo(() => (
  <FolderLibrary dataHook={useFolders(folderType, false)} />
));
export const createEditor = () => {
  const EditorProjectScreen = memo(() => <EditorProject />);
  const EditorStackScreen = () => {
    return (
      <EditorStack.Navigator
        screenOptions={{
          headerShown: false,
          freezeOnBlur: true,
        }}>
        <EditorStack.Screen
          name="EditorProjects"
          options={{orientation: 'portrait'}}
          component={FolderLibraryComponent}
        />
        <EditorStack.Screen
          name="EditorProject"
          options={{orientation: 'portrait'}}
          component={EditorProjectScreen}
        />
        <EditorStack.Screen
          name="Camera"
          component={CameraScreen}
          options={({route}) => ({
            // freezeOnBlur: true,
          })}
        />
        <EditorStack.Screen
          name="Folder"
          options={{orientation: 'portrait'}}
          component={FolderComponent}
        />
      </EditorStack.Navigator>
    );
  };
  return EditorStackScreen;
};
